import { Component, OnInit, Input } from '@angular/core';
import { WorkshopDefectFitter } from '../../models/workshop-defect-fitter.model';
import { WorkshopDefectFitterService } from '../../services/workshop-defect-fitter.service';
import { Fitter } from '../../../fitter/models/fitter.model';
import { FitterService } from '../../../fitter/services/fitter.service';
import { catchError, take } from 'rxjs/operators';
import moment from 'moment';

@Component({
    selector: 'app-workshop-defect-fitters',
    templateUrl: './workshop-defect-fitters.component.html',
    styleUrls: ['./workshop-defect-fitters.component.scss'],
    standalone: false
})
export class WorkshopDefectFittersComponent implements OnInit {

  @Input()
  workshopDefectId: number;

  assignments: WorkshopDefectFitter[] = [];
  fitters: Fitter[] = [];

  newFitterId: number = -1;
  newScheduledDate: string = '';

  constructor(
    private workshopDefectFitterService: WorkshopDefectFitterService,
    private fitterService: FitterService) { }

  ngOnInit(): void {
    this.loadAssignments();

    this.fitterService.getAllFitters()
    .pipe(catchError((e) => { alert('Fitters could not be loaded'); return e; }))
    .pipe(take(1))
    .subscribe((fitters: any) => {
      this.fitters = fitters;
      this.fitters.push({id: -1, firstName: 'Select a fitter...', lastName: ''} as any);
    });
  }

  loadAssignments(): void {
    this.workshopDefectFitterService.getByDefectId(this.workshopDefectId)
    .pipe(take(1))
    .subscribe((assignments: WorkshopDefectFitter[]) => {
      this.assignments = assignments;
    });
  }

  addFitter(): void {
    if(this.newFitterId === -1) {
      return;
    }

    this.workshopDefectFitterService.assignFitter(this.workshopDefectId, this.newFitterId, this.newScheduledDate || null)
    .pipe(take(1))
    .subscribe(() => {
      this.newFitterId = -1;
      this.newScheduledDate = '';
      this.loadAssignments();
    });
  }

  removeFitter(assignment: WorkshopDefectFitter): void {
    this.workshopDefectFitterService.removeAssignment(assignment.id)
    .pipe(take(1))
    .subscribe(() => {
      this.loadAssignments();
    });
  }

  updateHours(assignment: WorkshopDefectFitter): void {
    this.workshopDefectFitterService.updateAssignment(
      assignment.id, assignment.workshopDefectId, assignment.fitterId, assignment.scheduledDate, assignment.hours,
    )
    .pipe(take(1))
    .subscribe();
  }

  formatDate(date: string): string {
    if(!date) {
      return 'No date set';
    }
    return moment(date).format('DD/MM/YYYY');
  }

}
